

// Nuxt / Vendor
import Vue from "vue";

// Project
import Utils from "~/libs/Utils";

// Local Types

interface ComponentItem {
    name: string;
    props?: Record<string, any>;
    section: boolean;  // add section wrapper class
    contained: boolean;  // add container wrapper class
}

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component imports -------------------------------------------------------

    components: {
        PartialContent: () => import("~/components/PartialContent.vue"),
        AboutProfile: () => import("~/components/Blocks/AboutProfile.vue"),
        TestimonalList: () => import("~/components/Testimonials/List.vue"),
        TableOfContents: () => import("~/components/Blocks/TableOfContents.vue"),
        BlogFeedLinks: () => import("~/components/Blocks/BlogFeedLinks.vue"),
        SiblingLinks: () => import("~/components/Blocks/SiblingLinks.vue")
    },

    // Component Attribute Properties ------------------------------------------

    props: {
        components: {
            type: Array,
            required: true
        }
    },

    // Component Attribute, Properties & Injected ------------------------------

    computed: {
        items () : ComponentItem[] {
            return this.components.map(componentString => this.makeItem(componentString as string));
        }
    },

    // Methods / Functions  ----------------------------------------------------

    methods: {
        /**
         * Parse component string into component item.
         *
         * @param {string} componentString
         *
         * @return ComponentItem
         */
        makeItem (componentString: string): ComponentItem {
            const componentParts = componentString.split("|");

            // Create instance with default values
            const item = {} as ComponentItem;
            item.name = componentParts[0];
            item.section = false;
            item.contained = true;

            if (componentParts[1]) {
                this.makeProps(item, componentParts[1]);
            }

            return item;
        },

        /**
         * Parse a component sub string into a properties object.
         *
         * @param {string} componentString
         *
         * @retutn Record<string,any>
         */
        makeProps (item: ComponentItem, componentString: string): void {
            componentString
                .split(",")
                .forEach((propString) => {
                    const propParts = propString.split(":");

                    const propName = propParts[0] as string;
                    const propValue = propParts[1];

                    if (propName === "section" || propName === "contained") {
                        item[propName] = propValue === "true";
                        return;
                    }

                    item.props = item.props ?? {};
                    item.props[propName] = propValue;
                });
        },

        /**
         * Component item wrapper classes
         */
        wrapperClass (item: ComponentItem): Object {
            return {
                container: item.contained
            };
        },

        /**
         * Component item wrapper classes
         */
        componentClass (item: ComponentItem): Object {
            return {
                section: item.section
            };
        },

        /**
         * Outer wrapper classes.
         */
        itemClasses (item: ComponentItem): Array<string> {
            return [
                "page-component-item",
                "page-component-" + Utils.studlyToKebab(item.name)
            ];
        }
    }

    // -------------------------------------------------------------------------
});

